module.exports = __webpack_public_path__ + "img/character-img2.60e079b5.png";